import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../api';
import toast from 'react-hot-toast';

const s: any = {
  page:  { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f3f4f6' },
  box:   { background: 'white', padding: 40, borderRadius: 12, width: 380, boxShadow: '0 2px 16px rgba(0,0,0,0.08)' },
  label: { display: 'block', marginBottom: 6, fontWeight: 600, fontSize: 14 },
  input: { width: '100%', padding: '10px 12px', border: '1px solid #ddd', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' as any, marginBottom: 16 },
  btn:   { width: '100%', padding: 12, background: '#2563EB', color: 'white', border: 'none', borderRadius: 8, fontSize: 16, fontWeight: 600, cursor: 'pointer', marginTop: 8 }
};

export default function Signup() {
  const [form, setForm]       = useState({ email: '', phone: '', password: '', businessName: '' });
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e: React.FormEvent) => {
    e.preventDefault(); setLoading(true);
    try {
      const { data } = await api.post('/auth/signup', form);
      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
      toast.success('Account created!');
      nav('/dashboard');
    } catch (err: any) { toast.error(err.response?.data?.error || 'Signup failed'); }
    finally { setLoading(false); }
  };

  const upd = (k: string) => (e: React.ChangeEvent<HTMLInputElement>) =>
    setForm(f => ({ ...f, [k]: e.target.value }));

  return (
    <div style={s.page}>
      <form onSubmit={submit} style={s.box}>
        <h1 style={{ marginBottom: 8, fontSize: 24, fontWeight: 700 }}>Start Free Trial 🚀</h1>
        <p style={{ marginBottom: 24, color: '#666' }}>7 days free. No credit card needed.</p>
        <label style={s.label}>Business Name</label>
        <input value={form.businessName} onChange={upd('businessName')} type="text" style={s.input} />
        <label style={s.label}>Email</label>
        <input value={form.email} onChange={upd('email')} type="email" required style={s.input} />
        <label style={s.label}>Phone (with country code, e.g. +8801712345678)</label>
        <input value={form.phone} onChange={upd('phone')} type="tel" required style={s.input} />
        <label style={s.label}>Password</label>
        <input value={form.password} onChange={upd('password')} type="password" required style={s.input} />
        <button type="submit" disabled={loading} style={s.btn}>{loading ? 'Creating...' : 'Start Free Trial'}</button>
        <p style={{ textAlign: 'center', marginTop: 16, color: '#666' }}>
          Have an account? <Link to="/login" style={{ color: '#2563EB' }}>Login</Link>
        </p>
      </form>
    </div>
  );
}